const storeSettings = {
  maxProductCount: 5
};

export {
  storeSettings
};